import { ArrowUpRight } from "lucide-react";
import { MEDIA_AGE } from "@/lib/brand";

export const ULULE_URL = "https://fr.ulule.com/lgtdz/";
const IMG = (id) => `https://media.ulule.com/presales/0/0/${id}`;

export const STATS = [
  { value: String(MEDIA_AGE), label: "ans d'existence" },
  { value: "Des milliers", label: "d'articles" },
  { value: "200+", label: "événements organisés, couverts ou animés" },
];

export const WHY = [
  "Afin de pérenniser le média et agir dans le développement du paysage musical et culturel.",
  "Afin de permettre la multiplication des formats et happenings.",
  "Afin d'être toujours au plus près de l'évolution du mouvement.",
];

export const GOALS = [
  "Rester hors de la concentration des médias et l'uniformisation des lignes éditoriales.",
  "Construire une réelle alternative indépendante sans pub ni logique promotionnelle contrainte.",
  "La création d'un espace d'expression d'une scène sous-représentée dans l'espace public.",
];

export const PHOTOS = [
  { src: IMG("195db211-b6bb-40e5-ae09-b890aedf779c.oso8T7SYg3.jpg"), caption: "Concert-surprise de Keziah Jones sur la scène gratuite de Jazz à Vienne organisé par LGTDZ en 2018" },
  { src: IMG("eff9771e-9506-41e9-a4b6-73567518ad1e.0jN2JAuCPZ.jpg"), caption: "Mab'Ish à l'affiche des 10 ans de LGTDZ" },
  { src: IMG("e534d77e-5e0d-447a-a51b-8c7287aadd56.7xpxUnVtme.jpg"), caption: "Carte Blanche LGTDZ Jazz à Vienne avec Kohndo (La Cliqua) et De Phase" },
  { src: IMG("74f0a4c6-bcb9-4c84-8d9d-15bc0ee6b048.Xe7m1aiI36.jpg"), caption: "Rencontre littéraire avec Mathieu Rochet et Real Muzul (Get Busy / Clique TV)" },
];

export const MemberCta = ({ testId = "ulule-member-btn", className = "" }) => (
  <a href={ULULE_URL} target="_blank" rel="noreferrer" data-testid={testId}
    className={`inline-flex items-center gap-3 bg-primary text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200 ${className}`}>
    Devenir membre dès 2&nbsp;€/mois <ArrowUpRight className="w-5 h-5" />
  </a>
);

export const Stats = () => (
  <div className="grid sm:grid-cols-3 border-y border-white/10" data-testid="support-stats">
    {STATS.map((s, i) => (
      <div key={s.label} className={`py-10 sm:px-8 ${i ? "sm:border-l border-white/10" : ""}`}>
        <p className="font-display uppercase text-5xl lg:text-6xl text-primary leading-none">{s.value}</p>
        <p className="text-zinc-300 mt-3 text-lg">{s.label}</p>
      </div>
    ))}
  </div>
);

export const NumberedList = ({ items, testId }) => (
  <ul className="border-t border-white/10" data-testid={testId}>
    {items.map((p, i) => (
      <li key={p} className="flex gap-6 py-5 border-b border-white/10">
        <span className="font-display text-2xl text-primary">{String(i + 1).padStart(2, "0")}</span>
        <span className="text-zinc-200 text-base md:text-lg leading-relaxed">{p}</span>
      </li>
    ))}
  </ul>
);

export const PhotoGrid = () => (
  <div className="grid sm:grid-cols-2 gap-6" data-testid="support-photos">
    {PHOTOS.map((p) => (
      <figure key={p.src} className="group">
        <div className="overflow-hidden aspect-[4/3] bg-[hsl(var(--surface))]">
          <img src={p.src} alt={p.caption} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
        <figcaption className="text-zinc-400 text-sm mt-3">{p.caption}</figcaption>
      </figure>
    ))}
  </div>
);
